import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'addon-chip-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './addon-chip-bar.component.html',
})
export class AddonChipBarComponent {
  @Input() addons: { key: string; icon: string; label: string }[] = [];
  @Input() addLabel = 'Agregar:';
  @Output() activate = new EventEmitter<string>();
}
